import React from 'react';
import { type IconName, Icon } from '@noths/polaris-design-system-core-components';

import * as styles from './ProductBadge.styles';

export type ProductBadgeType = 'outOfStock' | 'unavailable' | 'new' | 'mostLoved';

export interface ProductBadgeProps {
  badge: ProductBadgeType;
}

const BADGE_CONFIG: Record<ProductBadgeType, { icon?: IconName; label: string; muted?: boolean }> =
  {
    mostLoved: { icon: 'mostLoved', label: 'Most loved' },
    new: { label: 'NEW' },
    outOfStock: { label: 'OUT OF STOCK', muted: true },
    unavailable: { label: 'UNAVAILABLE', muted: true },
  };

export const ProductBadge = ({ badge }: ProductBadgeProps) => {
  const { icon, label, muted } = BADGE_CONFIG[badge];

  return (
    <span css={[styles.root, muted && styles.muted]}>
      {icon ? (
        <>
          <Icon name={icon} size="sm" /> {label}
        </>
      ) : (
        label
      )}
    </span>
  );
};
